import React from "react";

const CollectionsContext = React.createContext({});
const DisclaimerProcessorContext = React.createContext({});
const SelectedLocaleContext = React.createContext({});
const ExposeContentContext = React.createContext({});
const PageInstanceContext = React.createContext({});
const ExportStateContext = React.createContext({});
const PageListContext = React.createContext({});
const AuthContext = React.createContext({});
const BijEnergyGenerationContext = React.createContext({});

export {
  AuthContext,
  CollectionsContext,
  DisclaimerProcessorContext,
  ExportStateContext,
  ExposeContentContext,
  PageInstanceContext,
  PageListContext,
  SelectedLocaleContext,
  BijEnergyGenerationContext
};
